export const validationMessages = {
  FIELD_REQUIRED: 'Campo requerido',
}